import { SelectField, SelectFieldProps } from "@homebound/beam";
import { ItemsDataFragment, useItemsSelectQuery } from "src/components/autoPopulateSelects/ItemsSelectField.generated";
import { ItemFilter } from "src/generated/graphqlTypes";

type ItemsSelectFieldProps = Omit<
  SelectFieldProps<ItemsDataFragment, string>,
  "options" | "multiselect" | "getOptionLabel" | "getOptionValue"
> & {
  getOptionLabel?: (o: ItemsDataFragment) => string;
  getOptionValue?: (o: ItemsDataFragment) => string;
  filter?: ItemFilter;
};

export function ItemsSelectField(props: ItemsSelectFieldProps) {
  const {
    placeholder = "Select an Item",
    getOptionLabel = ({ fullCode, name }) => `${fullCode} ${name}`,
    getOptionValue = (o) => o.id,
    filter = {},
    ...otherProps
  } = props;
  const { data, loading } = useItemsSelectQuery({
    fetchPolicy: "cache-first",
    variables: { filter: filter },
  });
  return (
    <SelectField
      {...otherProps}
      placeholder={loading ? "Loading..." : placeholder}
      options={data?.items ?? []}
      getOptionValue={getOptionValue}
      getOptionLabel={getOptionLabel}
    />
  );
}
